import type { BatchItem } from '@api/hooks/useBatch.ts';
import { type ColumnProps, Table } from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { BatchDesktopRenderers } from './BatchDesktopRenderers';

interface CollapsibleHeaderProps {
	items: BatchItem[];
	isLoading: boolean;
}

export const BatchTableDesktop = ({ items, isLoading }: CollapsibleHeaderProps) => {
	const { t } = useTranslation('', { keyPrefix: 'payments.batch.table' });
	const navigate = useNavigate();

	const columns: ColumnProps[] = [
		{
			label: t('file'),
			key: 'file',
			align: 'left',
		},
		{
			label: t('uploaded'),
			key: 'uploaded',
			align: 'left',
		},
		{
			label: t('operationsCount'),
			key: 'operations',
			align: 'left',
		},
		{
			label: t('status'),
			key: 'status',
			align: 'left',
		},
		{
			label: t('totalAmount'),
			key: 'amount',
			align: 'right',
		},
		{
			label: '',
			key: 'delete',
			align: 'right',
			width: '50px',
		},
	];

	const handleRowClick = (batch: BatchItem) => {
		navigate(`/operations/batch/${batch.uuid}`);
	};

	return (
		<Table
			columns={columns}
			isLoading={isLoading}
			onRowClick={handleRowClick}
			renders={BatchDesktopRenderers(t)}
			rows={items ?? ''}
		/>
	);
};
